var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageBox"},[_c('PageComponent',{attrs:{"publicTemplateName":"报考未学习","publicStatus":1500}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }